module.exports = __webpack_public_path__ + "20250721160708/img/sqqr.c5b50041.png";